import React, { Fragment } from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';

import { H5, H6 } from '../../../AbstractElements';
import { RecentActivityData } from '../../../Data/Widgets/general/index';
import { RecentActivityTitle } from '../../../Constant';
import { FiClock } from 'react-icons/fi';
import msToTime from '../../../Utils/helper/msToTime';

const RecentActivity = () => {
  return (
    <Fragment>
      <Col xl='4' md='6 lg-50 box-col-4 dash-lg-50' className='activity-widget'>
        <div>
          <Card className='recent-activity'>
            <CardHeader className='border-bottom'>
              <H5>{RecentActivityTitle}</H5>
            </CardHeader>
            <CardBody>
              <div className='activity-media'>
                {RecentActivityData.map((item) => (
                  <div key={item.id} className='d-flex'>
                    <div className={`recent-circle bg-${item.color}`}></div>
                    <div className='flex-grow-1'>
                      <H6 className='font-roboto'>{item.title}</H6>
                      <span>
                        <FiClock className='me-2' />
                        <span className='font-roboto'>
                          {item.date} | {msToTime(item.time, 'ago', 'long')}
                        </span>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>
        </div>
      </Col>
    </Fragment>
  );
};
export default RecentActivity;
